import { ShieldUser } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * Marks UI that is shown only because the current user is a backoffice user.
 */
export function BackofficeOnly({ className }: { className?: string }) {
  return (
    <ShieldUser
      aria-hidden
      className={cn('size-4 text-current opacity-60', className)}
    />
  );
}
